import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '50px',
    boxSizing: 'border-box',
    height: '29px',
    padding: '0 8px',
    background: '#F0F0F0',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    cursor: 'pointer'
  },

  count: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '4px',
    borderRadius: '8px',
    height: '16px',
    padding: '0 4px',
    background: '#C6C6C6',
    fontSize: theme.size.sm,
    color: '#1F1F1F'
  },

  selected: {
    background: theme.palette.primary.main,
    color: '#FFFFFF'
  }
}))

export default useStyles
